import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setCartItemRatePlanHelper = (
  state: EngineStoreData,
  ratePlan: RatePlanMerged,
  itemId: string,
) => ({
  cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
    if (CAI.id === itemId) {
      return {
        ...CAI,
        ratePlan,
        optionalExtras: [],
        mandatoryExtras: [],
      };
    }
    return CAI;
  }),
});
